import {useState, useEffect} from "react";
import {
  ApiResponseFromCMS,
  IClusterDataFromServer,
} from "../pages/Dashboard/Dashboard.type";

const useFetchDataTechClusterById = (
  apiUrl: string,
  apiKey: string,
  clusterId: string
) => {
  const [clusterData, setClusterData] =
    useState<ApiResponseFromCMS<IClusterDataFromServer> | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!clusterId) {
      setClusterData(null);
      return;
    }

    let isCancelled = false;
    setClusterData(null);

    const headers = new Headers({
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    });

    const url = new URL(`${apiUrl}/${clusterId}`);
    url.searchParams.set("populate", "*");

    fetch(url.href, {method: "GET", headers})
      .then((response) => response.json())
      .then((data: ApiResponseFromCMS<IClusterDataFromServer>) => {
        if (isCancelled) return;
        if (data?.data?.technologies) {
          data = {
            ...data,
            data: {
              ...data.data,
              technologies: data.data.technologies.filter(
                (tech) => tech.molecule_only !== true
              ),
            },
          };
        }
        setClusterData(data);
      })
      .catch((error) => {
        if (isCancelled) return;
        setError(error);
      });

    return () => {
      isCancelled = true;
    };
  }, [apiUrl, apiKey, clusterId]);

  return {clusterData, error};
};

export default useFetchDataTechClusterById;
